(function (RuleEffect) {
    RuleEffect[RuleEffect["HIDE"] = 'HIDE'] = "HIDE";
    RuleEffect[RuleEffect["SHOW"] = 'SHOW'] = "SHOW";
    RuleEffect[RuleEffect["ENABLE"] = 'ENABLE'] = "ENABLE";
    RuleEffect[RuleEffect["DISABLE"] = 'DISABLE'] = "DISABLE";
})(exports.RuleEffect || (exports.RuleEffect = {}));
var RuleEffect = exports.RuleEffect;
//# sourceMappingURL=uischema.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/jsonforms/uischema.js
 ** module id = 872
 ** module chunks = 2
 **/